import Button from 'components/ui/Button'
import InputTextField from 'components/ui/InputTextField'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link, useNavigate } from 'react-router-dom'
import { USER_SIGN_UP } from '../../../../redux/types/auth.types'
import { authActions } from '../../../../redux/slice/auth.slice'

const SignUpForm = ( ) => {
    const dispatch = useDispatch()
    const submitHandler = (e) => {
        e.preventDefault();
        dispatch({type : USER_SIGN_UP , payload : signUpData});
        // setTab();
    }

        const navigate = useNavigate();
       const auth = useSelector(authActions.selectors.getLoggedInStatus);
       useEffect(()=>{
        if(auth){
            navigate('/')
        }
       },[auth, navigate])

    const [signUpData, setSignUpData] = useState({
        name : '',
        email : '',
        phone_number : '',
        password : '',
        confirmPassowrd : ''
    })

    const handleSignUpForm = (name , value) => {
        // switch(name){
        //     case 'password':
        //         console.log("Hello");
        //         break
        //     case 'confirmPassowrd':
        //         console.log("confirmPassowrd");
        //         break
        //     default:
        //         console.log("World")
        // }
        setSignUpData({
            ...signUpData,
            [name] : value
        })
    }

    return (
        <form className="flex flex-wrap flex-col justify-center px-1  h-svh md:px-32" onSubmit={submitHandler}>
            <div className="text-3xl font-bold">Sign up</div>
            <div className="mt-3 text-lg text-lightGrey">
                Please enter your details to get started
            </div>

            <div className="mt-6">
                <InputTextField
                    label="Name*"
                    type="text"
                    name="name"
                    placeholder="Enter your full name"
                    onChange={handleSignUpForm}
                />
            </div>

            <div className="mt-1">
                <InputTextField
                    label="Email*"
                    type="text"
                    placeholder="Enter your email "
                    onChange={handleSignUpForm}
                    name='email'
                    required={true}
                />
            </div>

            <div className="mt-1">
                <InputTextField
                    label="Phone number*"
                    type="number"
                    placeholder="Enter your number "
                    name='phone_number'
                    onChange={handleSignUpForm}
                    required={true}
                />
            </div>

            <div className="mt-1">
                <InputTextField
                    label="Password*"
                    type="password"
                    placeholder="Create a password "
                    name='password'
                    onChange={handleSignUpForm}
                    required={true}
                />
            </div>
            <div className="mt-1 text-lightGrey text-[12px]">
                Must be at least 8 characters.
            </div>

            <div className="mt-1">
                <InputTextField
                    label="Confirm Password*"
                    type="password"
                    placeholder="Confirm Password"
                    name='confirmPassowrd'
                    onChange={handleSignUpForm}
                    required={true}
                />
            </div>

            <div className="mt-6">
                <Button title="Create Account" />
            </div>

            <div className="mt-3 flex justify-center text-xs font-semibold gap-1">
                <div className="text-lightGrey">Already have an account?</div>
                <Link to="/" className="text-secondary" >
                    Log in
                </Link>
            </div>
        </form>
    )
}

export default SignUpForm